module.exports = __webpack_public_path__ + "static/media/img-noise-beach.a07c4a02.png";